import { render, staticRenderFns } from "./vs-form-checkbox.vue?vue&type=template&id=0f4c893e&scoped=true"
import script from "./vs-form-checkbox.vue?vue&type=script&lang=js"
export * from "./vs-form-checkbox.vue?vue&type=script&lang=js"
import style0 from "./vs-form-checkbox.vue?vue&type=style&index=0&id=0f4c893e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c893e",
  null
  
)

export default component.exports